import { render } from "./ModalChooseProduct.vue?vue&type=template&id=8ff7aeea"
import script from "./ModalChooseProduct.vue?vue&type=script&lang=js"
export * from "./ModalChooseProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__